import React, { useState } from 'react'
import RandomService from '../../component/Home/RandomServices'
import RandomPackage from '../../component/Home/RandomPackage'
import Contact from '../../component/Home/Contact'
import Info from '../../component/Home/Info'
import Request from '../../component/Home/Request'
import './home.scss'
import LandingPage2 from './LandingPage2'

import { FaFacebook, FaInstagram, FaMapMarkedAlt, FaWhatsapp, FaPoll, FaPlus, FaShareAlt, FaTimes ,  FaSnapchatGhost, FaTiktok  } from 'react-icons/fa'; // Import the survey icon
import { useTranslation } from 'react-i18next'
const socialLinks = [
  { href: 'https://form.svhrt.com/690b19ee03886962930a9860', icon: <FaPoll />, color: 'bg-purple-500', name: 'Survey' },
  { href: 'https://maps.app.goo.gl/kKYqeoCXXftTi9va8', icon: <FaMapMarkedAlt />, color: 'bg-red-500', name: 'Location' },
  { href: 'https://api.whatsapp.com/send/?phone=971501344319&text&type=phone_number&app_absent=0', icon: <FaWhatsapp />, color: 'bg-green-500', name: 'WhatsApp' },
  { href: 'https://www.facebook.com/profile.php?id=61587114271681', icon: <FaFacebook />, color: 'bg-blue-600', name: 'Facebook' },
  { href: 'https://www.instagram.com/laboratory.cmp', icon: <FaInstagram />, color: 'bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600', name: 'Instagram' },
  {
    href: 'https://www.tiktok.com/@cmp_laboratory?_r=1&_t=ZS-93KkysfFcCm',
    icon: <FaTiktok />,
    color: 'bg-black hover:bg-gradient-to-tr hover:from-[#25F4EE] hover:to-[#FE2C55]',
    name: 'TikTock',
  },
  {
    href: 'https://www.snapchat.com/add/cmplab?share_id=2QxqGlMRjTY&locale=en-GB',
    icon: <FaSnapchatGhost />,
    color: 'bg-yellow-400 hover:bg-yellow-500',
    name: 'Snapchat',
  }
];

// const FloatingSocialMedia = () => {
//   const [isOpen, setIsOpen] = useState(false);

//   return (
//     <div 
//       className="fixed right-[-90px] bottom-6 md:right-10 md:bottom-10 flex flex-col items-end z-[9999]"
      
//     >
//       {/* Expanded Menu */}
//       <div className={`flex flex-col items-end gap-3 mb-4 transition-all duration-500 ease-out transform ${
//         isOpen ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-10 scale-50 pointer-events-none'
//       }`}
//       onMouseEnter={() => setIsOpen(true)}
//       onMouseLeave={() => setIsOpen(false)}
//       >
//         {socialLinks.map((link, index) => (
//           <div
//             key={index}
//             className="group flex items-center gap-3"
//             style={{ transitionDelay: `${index * 50}ms` }}
//           >
//             {/* Glassmorphism Label */}
//             <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 px-3 py-1.5 rounded-lg bg-white/80 backdrop-blur-md border border-gray-200 text-primeColor text-sm font-bold shadow-sm whitespace-nowrap">
//               {link.name}
//             </span>
            
//             {/* Icon Button */}
//             <a
//               href={link.href}
//               target="_blank"
//               rel="noopener noreferrer"
//               className={`${link.color} text-white w-12 h-12 flex items-center justify-center rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 active:scale-90`}
//               aria-label={link.name}
//             >
//               <span className="text-xl">{link.icon}</span>
//             </a>
//           </div>
//         ))}
//       </div>

//       {/* Main Toggle Button */}
//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center text-white shadow-2xl transition-all duration-500 transform ${
//           isOpen ? 'bg-primeColor rotate-180' : 'bg-secondColor'
//         } hover:scale-110 active:scale-95`}
//       >
//         {isOpen ? (
//           <FaTimes className="text-2xl" />
//         ) : (
//           <div className="relative">
//              <FaPlus className="text-2xl" />
//              {/* Pulsing Notification Dot */}
//              {!isOpen && (
//                <span className="absolute -top-1 -right-1 flex h-3 w-3">
//                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
//                  <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
//                </span>
//              )}
//           </div>
//         )}
//       </button>
//     </div>
//   );
// };



const FloatingSocialMedia = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { i18n } = useTranslation();

  const isRTL = i18n.language === "ar";

  return (
    <div
      dir={isRTL ? "rtl" : "ltr"}
      className={`
        fixed bottom-6 md:bottom-10 flex flex-col items-end z-[9999]
        ${isRTL ? "left-[5px] md:left-[5px] items-start" : "right-[5px] md:right-[5px]"}
      `}
    >
      {/* Expanded Menu */}
      <div
        className={`flex flex-col gap-3 mb-4 transition-all duration-500 ease-out transform
        ${isOpen ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-10 scale-50 pointer-events-none"}
        ${isRTL ? "items-start" : "items-end"}
        `}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {socialLinks.map((link, index) => (
          <div
            key={index}
            className={`group flex items-center gap-3 ${isRTL ? "flex-row-reverse" : ""}`}
            style={{ transitionDelay: `${index * 50}ms` }}
          >
            {/* Label */}
            <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 px-3 py-1.5 rounded-lg bg-white/80 backdrop-blur-md border border-gray-200 text-primeColor text-sm font-bold shadow-sm whitespace-nowrap">
              {link.name}
            </span>

            {/* Icon */}
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`${link.color} text-white w-12 h-12 flex items-center justify-center rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 active:scale-90`}
              aria-label={link.name}
            >
              <span className="text-xl">{link.icon}</span>
            </a>
          </div>
        ))}
      </div>

      {/* Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center text-white shadow-2xl transition-all duration-500 transform
        ${isOpen ? "bg-primeColor-500/50 rotate-180" : "bg-secondColor"}
        hover:scale-110 active:scale-95`}
      >
        {isOpen ? <FaTimes className="text-2xl" /> : <FaPlus className="text-2xl" />}
      </button>
    </div>
  );
};
const Home = () => {
  return (
    <div className='min-h-[90vh] bg-white home'>
      <LandingPage2/>
      <RandomService/>
      <RandomPackage />
      <Contact/>
      <Info/>
      <Request/>
      <FloatingSocialMedia/>

    </div>
  )
}

export default Home